import NewsletterSectionImplementation from '../implementation/sections/NewsletterSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiNewsletterSectionDTO,
  NewsletterSectionDTO,
} from '@lib/strapi/dtos/components/sections/newsletterSection.dto';

const NewsletterSection = (props: ComponentProps<NewsletterSectionDTO>) => {
  return <NewsletterSectionImplementation {...props}></NewsletterSectionImplementation>;
};

export default NewsletterSection;
